import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';

@Component({
  selector: 'app-general-calc-salary-inputs',
  templateUrl: './general-calc-salary-inputs.component.html',
  styleUrls: ['./general-calc-salary-inputs.component.scss']
})
export class GeneralCalcSalaryInputsComponent implements OnInit {

  @ViewChild('formRef', { static: false }) form: DxFormComponent;

  // Input: استقبال البيانات الأولية من الـ Parent
  @Input() initialFormData: any = {};
  @Input() currentLang: string = 'ar';
  @Input() monthFromParent: number = 0;
  @Input() yearFromParent: number = 0;
  @Input() salaryvocabularyid: number = 0;

  // Output: إرسال كل التغييرات للـ Parent في object واحد
  @Output() formDataChanged = new EventEmitter<any>();

  // Form Data
  SallaryForm: any = {};
  currentDate: Date = new Date();
  isValid: boolean;
  // Dropdowns
  branchesdropdown: any = [];
  jobTitleDropDown: any = [];
  bankDropDown: any = [];
  departmentDropDown: any = [];
  managementDropDown: any = [];
  WorkSystemDropDown: any = [];
  employeeinformation: any = [];
  salarytype: any = [];

  // Selected Values
  selectedBranch: number[] = [];
  selectedJob: number[] = [];
  selectedManagement: number[] = [];
  selectedDepartment: number[] = [];
  selectedWorkSystem: number[] = [];
  selectedEmployee: number[] = [];

  // Filter columns for employee dropdown
  employeeColumns = [
    { dataField: 'employeeNameAr', caption: '', allowColumnResizing: true },
    { dataField: 'branchName', caption: '', allowColumnResizing: true },
    { dataField: 'employeeWorkStatus', caption: '', allowColumnResizing: true },
    { dataField: 'departmentName', caption: '', width: 100 },
    { dataField: 'managementName', caption: '', width: 100 },
    { dataField: 'jobName', caption: '', allowColumnResizing: true },
    { dataField: 'employeeWorkSystem', caption: '', allowColumnResizing: true }
  ];

  filteredEmployeeColumns: any[] = [];

  constructor(
    public translate: TranslateService,
    private gt: genericCustomStoreService
  ) {}

  ngOnInit(): void {
    this.initializeColumns();
    this.loadAllDropdowns();
    
    // Initialize form with input data
    if (this.initialFormData && Object.keys(this.initialFormData).length > 0) {
      this.SallaryForm = { ...this.initialFormData };
      this.mapInputDataToSelections();
    }
  }

  ngOnChanges(): void {
    // Update form when parent changes input
    if (this.initialFormData) {
      this.SallaryForm = { ...this.initialFormData };
      this.mapInputDataToSelections();
    }
  }

  initializeColumns(): void {
    this.employeeColumns = [
      {
        dataField: 'employeeNameAr',
        caption: this.translate.instant('hr.employeeId'),
        allowColumnResizing: true
      },
      {
        dataField: 'branchName',
        caption: this.translate.instant('basic-info.branch.branchName'),
        allowColumnResizing: true
      },
      {
        dataField: 'employeeWorkStatus',
        caption: this.translate.instant('hr.EmployeeStatus'),
        allowColumnResizing: true
      },
      {
        dataField: 'departmentName',
        caption: this.translate.instant('salary.department'),
        width: 100
      },
      {
        dataField: 'managementName',
        caption: this.translate.instant('salary.management'),
        width: 100
      },
      {
        dataField: 'jobName',
        caption: this.translate.instant('salary.jobTitleId'),
        allowColumnResizing: true
      },
      {
        dataField: 'employeeWorkSystem',
        caption: this.translate.instant('salary.workSystem'),
        allowColumnResizing: true
      }
    ];

    this.filteredEmployeeColumns = this.employeeColumns.filter(col =>
      ['employeeNameAr', 'branchName', 'departmentName', 'employeeWorkStatus', 'employeeWorkSystem', 'managementName'].includes(col.dataField)
    );
  }

  loadAllDropdowns(): void {
    // Load all dropdowns
    this.gt.getdropdowndata('Branch').subscribe((res: []) => {
      this.branchesdropdown = res;
    });

    this.gt.getdropdowndata('JobTitle').subscribe((res: []) => {
      this.jobTitleDropDown = res;
    });

    this.gt.getdropdowndata('Bank').subscribe((res: []) => {
      this.bankDropDown = res;
       if(this.bankDropDown.length > 0&& (this.SallaryForm.id === 0||this.SallaryForm.id===undefined|| this.SallaryForm.id == null)) {
          this.SallaryForm.bankId = this.bankDropDown[0].id;    

        }
    });

    this.gt.getdropdowndata('Department').subscribe((res: []) => {
      this.departmentDropDown = res;
    });

    this.gt.getdropdowndata('Management').subscribe((res: []) => {
      this.managementDropDown = res;
    });

    this.gt.getdropdowndata('WorkSystem').subscribe((res: []) => {
      this.WorkSystemDropDown = res;
    });

    this.gt.dropdown('EmployeeSalaryVocabulary/salaryType').subscribe((res: []) => {
      this.salarytype = res;
    });

    this.gt.dropdown('Employee/GetDropDown/EmployeeInformation').subscribe((res: []) => {
      this.employeeinformation = res;
    });
  }

  mapInputDataToSelections(): void {
    // Map input data to selected arrays
    if (this.SallaryForm.branchIds) {
      this.selectedBranch = Array.isArray(this.SallaryForm.branchIds) 
        ? this.SallaryForm.branchIds 
        : [this.SallaryForm.branchIds];
    }
    if (this.SallaryForm.jobTitleIds) {
      this.selectedJob = Array.isArray(this.SallaryForm.jobTitleIds) 
        ? this.SallaryForm.jobTitleIds 
        : [this.SallaryForm.jobTitleIds];
    }
    if (this.SallaryForm.managementIds) {
      this.selectedManagement = Array.isArray(this.SallaryForm.managementIds) 
        ? this.SallaryForm.managementIds 
        : [this.SallaryForm.managementIds];
    }
    if (this.SallaryForm.departmentIds) {
      this.selectedDepartment = Array.isArray(this.SallaryForm.departmentIds) 
        ? this.SallaryForm.departmentIds 
        : [this.SallaryForm.departmentIds];
    }
    if (this.SallaryForm.workSystemIds) {
      this.selectedWorkSystem = Array.isArray(this.SallaryForm.workSystemIds) 
        ? this.SallaryForm.workSystemIds 
        : [this.SallaryForm.workSystemIds];
    }
    if (this.SallaryForm.employeeId) {
      this.selectedEmployee = [this.SallaryForm.employeeId];
    }
  }

  // Date change handler
  datechanged(e: any): void {
    this.SallaryForm.fromDate = e.startDate;
    this.SallaryForm.toDate = e.endDate;
    this.emitFormData();
  }

  // Selection handlers
  onBranchSelectionChanged(selectedRowKeys: number[]): void {
    this.selectedBranch = selectedRowKeys;
    this.SallaryForm.branchIds = selectedRowKeys;
    this.emitFormData();
  }

  onJobTitleSelectionChanged(selectedRowKeys: number[]): void {
    this.selectedJob = selectedRowKeys;
    this.SallaryForm.jobTitleIds = selectedRowKeys;
    this.emitFormData();
  }

  onManagementSelectionChanged(selectedRowKeys: number[]): void {
    this.selectedManagement = selectedRowKeys;
    this.SallaryForm.managementIds = selectedRowKeys;
    this.emitFormData();
  }

  onDepartmentSelectionChanged(selectedRowKeys: number[]): void {
    this.selectedDepartment = selectedRowKeys;
    this.SallaryForm.departmentIds = selectedRowKeys;
    this.emitFormData();
  }

  onWorkSystemSelectionChanged(selectedRowKeys: number[]): void {
    this.selectedWorkSystem = selectedRowKeys;
    this.SallaryForm.workSystemIds = selectedRowKeys;
    this.emitFormData();
  }

  onEmployeeSelectionChanged(selectedRowKeys: number[]): void {
    this.selectedEmployee = selectedRowKeys;
    this.SallaryForm.employeeIds = selectedRowKeys;
    this.emitFormData();
  }

  // Emit complete form data to parent
  emitFormData(): void {
    const completeFormData = {
      ...this.SallaryForm,
      branchIds: this.selectedBranch,
      jobTitleIds: this.selectedJob,
      managementIds: this.selectedManagement,
      departmentIds: this.selectedDepartment,
      workSystemIds: this.selectedWorkSystem,
      employeeIds: this.selectedEmployee
    };

    this.formDataChanged.emit(completeFormData);
  }

  // Reset form
  resetForm(): void {
    const registrationDateValue = this.SallaryForm.registrationDate;
    this.SallaryForm = {
      registrationDate: new Date(Date.now()).toISOString(),
      exchangeDate: new Date(Date.now()).toISOString()
    };
    
    this.selectedBranch = [];
    this.selectedJob = [];
    this.selectedManagement = [];
    this.selectedDepartment = [];
    this.selectedWorkSystem = [];
    this.selectedEmployee = [];

    if (this.form) {
      this.form.instance.resetValues();
      this.form.instance.updateData('registrationDate', registrationDateValue);
    }

    this.emitFormData();
  }

  // Public method to validate form (called from parent)
  validateForm(): any {
    if (this.form) {
      const validationResult = this.form.instance.validate();
      return (validationResult.isValid); 
    }
    return false;
  }

  // Public method to get form data (called from parent)
  getFormData(): any {
    return {
      ...this.SallaryForm,
      BranchIds: this.selectedBranch,
      jobTitleIds: this.selectedJob,
      managementIds: this.selectedManagement,
      departmentIds: this.selectedDepartment,
      workSystemIds: this.selectedWorkSystem,
      employeeIds: this.selectedEmployee
    };
  }



  
}